"use client";

import { CandleSetupGroup, DataItem } from "@/types";
import { CandlePatternInfo } from "@/lib/candlePatternInfo";
import SignalWorkspace from "./SignalWorkspace";

interface StructureTabProps {
  items: DataItem[];
  uniqueTypes: string[];
  setupGroups?: CandleSetupGroup[];
  selectedType: string | null;
  onSelectType: (type: string | null) => void;
  selectedPatternInfo: CandlePatternInfo | null;
  trendFilter: "all" | "up" | "down";
  setTrendFilter: (filter: "all" | "up" | "down") => void;
}

export default function StructureTab(props: StructureTabProps) {
  return (
    <SignalWorkspace
      {...props}
      mode="structure"
      title="Structure Context Scanner"
      description="Review the live structure families first, then use each result to confirm whether the candlestick context supports the setup."
      emptyMessage="Select a structure family from the explorer to review its current matches and supporting context."
    />
  );
}
